import { forwardRef, type Ref, type SVGProps } from "react";
const IconSignatureOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29 24.189H15.5c.3-1.4.5-2.9.7-4.6 1.4-.9 2.6-1.6 3.2-1.9 1-.5 1.7-.5 1.8-.5 0 0 .2.3-.2 1.3-.3.9-1 2.3-1 2.3-.2.5-.1 1 .4 1.3.4.3 1 .2 1.3-.2 2.2-2.6 5.1-5.4 6.4-6.2-.1.5-.4 1.5-1.1 3.1-.2.5 0 1.1.5 1.3s1.1 0 1.3-.5c1.5-3.6 1.7-5.2.6-6-.5-.3-1.6-1-6.2 3.6 0-.7-.3-1.2-.7-1.6-.8-.7-2.3-.7-4 .2 0 0-.9.4-2.1 1.2 0-.6.1-1.2.1-1.8.1-.8.1-1.6.2-2.4 3.1-2.3 5.9-5.9 5.5-8.5-.2-1-.8-1.8-1.9-2.1-1.2-.4-2.1-.1-2.6.3-1.9 1.2-2.5 4.8-2.9 9.2-2.4 1.6-5.2 2.5-5.2 2.5-.5.2-.8.7-.7 1.2.2.5.7.8 1.3.6.1 0 2.2-.7 4.4-1.9 0 .3 0 .6-.1.9-.1 1.1-.2 2.2-.3 3.4-2.3 1.5-4.9 3.6-6.2 5.8H3c-.5 0-1 .4-1 1s.5 1 1 1h4.2c-.6 2.1.4 3.1.9 3.5s1.1.5 1.8.5c1.3 0 2.8-.7 3.8-1.8.5-.6.8-1.3 1.2-2.2H29c.5 0 1-.4 1-1s-.5-1-1-1m-10.1-20c.1-.1.2-.1.4-.1.1 0 .3 0 .4.1.4.1.5.3.5.5.2 1.1-1.1 3.3-3.2 5.3.4-2.8.9-5.2 1.9-5.8m-4.9 16.9c-.2 1.1-.3 2.2-.6 3.1h-2.8c.9-1.1 2.1-2.1 3.4-3.1m-1.8 6c-.9 1.1-2.4 1.3-2.9 1-.4-.2-.3-.9.1-1.8h3.4c-.2.2-.4.5-.6.8"
    />
    <path
      fill="currentColor"
      d="M6.7 20.489c.4.4.4 1 0 1.4-.2.2-.5.3-.7.3s-.5-.1-.7-.3l-.8-.8-.8.8c-.2.2-.5.3-.7.3s-.5-.1-.7-.3c-.4-.4-.4-1 0-1.4l.8-.8-.8-.8c-.4-.4-.4-1 0-1.4s1-.4 1.4 0l.8.8.8-.8c.4-.4 1-.4 1.4 0s.4 1 0 1.4l-.8.8z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSignatureOutlineSVG);
ForwardRef.displayName = "IconSignatureOutline";
export { ForwardRef as IconSignatureOutline };
